import { useStore } from '@/store'
import { computed } from 'vue'

export default function useCurrentDealer() {
  const store = useStore()
  const currentDealer = computed(() => store.state.ApplicationStore.currentDealer)
  return currentDealer
}
